import { render, staticRenderFns } from "./FinancialSponsorAddress.vue?vue&type=template&id=293c1baf&scoped=true&"
import script from "./FinancialSponsorAddress.vue?vue&type=script&lang=ts&"
export * from "./FinancialSponsorAddress.vue?vue&type=script&lang=ts&"
import style0 from "./FinancialSponsorAddress.vue?vue&type=style&index=0&id=293c1baf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293c1baf",
  null
  
)

export default component.exports